import { render, staticRenderFns } from "./Assignees.vue?vue&type=template&id=72011238"
import script from "./Assignees.vue?vue&type=script&lang=js"
export * from "./Assignees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports